
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('pageContent', { breadcrumbs: 'getBreadcrumbs' })
    },
    methods: {
      visibility (crumb) {
        return ['mobile', 'tablet', 'desktop'].find(v => v === crumb[2]);
      }
    }
  };
